<template>
  <v-card variant="outlined" class="fill-height">
    <v-card-title class="d-flex flex-wrap align-center justify-space-between ga-3">
      <div>
        <div class="text-subtitle-1 font-weight-bold">
          {{ $t("ncrm.integrations.externalApi.endpoints.title") }}
        </div>
        <div class="text-body-2 text-medium-emphasis">
          {{ $t("ncrm.integrations.externalApi.endpoints.subtitleSprint2") }}
        </div>
      </div>
      <v-btn color="primary" variant="tonal" @click="$emit('create')">
        <v-icon start>mdi-plus</v-icon>
        {{ $t("ncrm.integrations.externalApi.endpoints.actions.new") }}
      </v-btn>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-4" />

      <div class="d-flex flex-column ga-3 mb-4">
        <v-text-field
          v-model="search"
          :label="$t('ncrm.integrations.externalApi.endpoints.filters.search')"
          hide-details="auto"
        />
        <v-select
          v-model="statusFilter"
          :items="statusFilterItems"
          item-title="label"
          item-value="value"
          :label="$t('ncrm.integrations.externalApi.endpoints.filters.status')"
          hide-details="auto"
        />
      </div>

      <v-list
        v-if="filteredEndpoints.length"
        class="pa-0"
        lines="three"
        density="comfortable"
      >
        <v-list-item
          v-for="endpoint in filteredEndpoints"
          :key="endpoint.id"
          :active="endpoint.id === selectedEndpointId"
          rounded="lg"
          class="mb-2"
          @click="$emit('select', endpoint.id)"
        >
          <template #prepend>
            <v-icon size="20">mdi-api</v-icon>
          </template>
          <v-list-item-title class="font-weight-medium">
            {{ endpoint.name }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ endpoint.endpoint_key }}
          </v-list-item-subtitle>
          <div class="text-caption text-medium-emphasis mt-2">
            {{ endpoint.source_system || "-" }} · {{ endpoint.template_key || "custom" }}
          </div>
          <div class="d-flex flex-wrap ga-2 mt-3">
            <v-chip size="small" :color="statusMeta(endpoint.status).color" :variant="statusMeta(endpoint.status).variant">
              {{ endpoint.status }}
            </v-chip>
            <v-chip color="info">
              {{ endpoint.entity_scope }}
            </v-chip>
            <v-chip color="secondary">
              {{ endpoint.active_key_count || 0 }} {{ $t("ncrm.integrations.externalApi.endpoints.keysLabel") }}
            </v-chip>
            <v-chip color="success">
              {{ endpoint.delivery_count_24h || 0 }} {{ $t("ncrm.integrations.externalApi.endpoints.deliveries24h") }}
            </v-chip>
            <v-chip
              v-if="endpoint.failed_count_24h"
              color="error"
            >
              {{ endpoint.failed_count_24h }} {{ $t("ncrm.integrations.externalApi.endpoints.failed24h") }}
            </v-chip>
          </div>
          <div class="text-caption text-medium-emphasis mt-3">
            {{ $t("ncrm.integrations.externalApi.endpoints.lastDeliveryLabel") }}:
            {{ formatDate(endpoint.last_delivery_at) }}
          </div>
        </v-list-item>
      </v-list>

      <div v-else class="py-8 text-center text-body-2 text-medium-emphasis">
        {{ endpoints.length ? $t("ncrm.integrations.externalApi.endpoints.emptyFiltered") : $t("ncrm.integrations.externalApi.endpoints.emptySprint2") }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  filterExternalApiEndpoints,
  formatExternalApiDateTime,
  resolveExternalApiStatusMeta,
} from "@/Utile/ncrmExternalApi.mjs";

export default {
  name: "NcrmExternalApiEndpointListCard",
  props: {
    endpoints: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    selectedEndpointId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      search: "",
      statusFilter: "all",
    };
  },
  computed: {
    filteredEndpoints() {
      return filterExternalApiEndpoints(this.endpoints, {
        search: this.search,
        status: this.statusFilter,
      });
    },
    statusFilterItems() {
      return [
        { label: this.$t("ncrm.integrations.externalApi.endpoints.filters.all"), value: "all" },
        { label: this.$t("ncrm.integrations.externalApi.endpoints.filters.options.active"), value: "active" },
        { label: this.$t("ncrm.integrations.externalApi.endpoints.filters.options.draft"), value: "draft" },
        { label: this.$t("ncrm.integrations.externalApi.endpoints.filters.options.paused"), value: "paused" },
        { label: this.$t("ncrm.integrations.externalApi.endpoints.filters.options.archived"), value: "archived" },
      ];
    },
  },
  methods: {
    statusMeta(status) {
      return resolveExternalApiStatusMeta(status);
    },
    formatDate(value) {
      return formatExternalApiDateTime(value);
    },
  },
};
</script>
